export const PANDIUM_SUCCESS = 'pandium-success'

export const PANDIUM_EVENT_ORIGINS = [
    'https://emp.sandbox.pandium.com',
    'https://emp.demo.pandium.com',
]
